import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { map } from 'rxjs';
import CountryCodes from 'src/app/core/constants/country-codes';
import CollectionHelper from 'src/app/core/helpers/collection.helper';
import { CountryListModel, CountryService, FilterOfStringFilterType, FilterPagingModel, ListItemModel, SortDirection, StringFilterType } from 'src/app/core/services/api-services';

@Component({
    selector: 'app-country-autocomplete-select',
    templateUrl: './country-autocomplete-select.component.html',
    styleUrl: './country-autocomplete-select.component.scss',
    standalone: false
})
export class CountryAutocompleteSelectComponent {
  @Input() itemControl!: FormControl;
  @Input() label!: string;
  @Input() error: string | null = null;
  @Output() selected = new EventEmitter<CountryListModel>();

  constructor(private readonly countryService: CountryService) { }

  search = (value: string | null) => {
    return this.countryService.paged({
      pageIndex: 1,
      pageSize: 1000,
      sort: 'name',
      sortDir: SortDirection.Asc,
      stringFilters: [{
        filterType: StringFilterType.Contains,
        values: [value ?? ''],
        name: 'name'
      } as FilterOfStringFilterType]
    } as FilterPagingModel)
      .pipe(map(paged => {
        const items = paged.items;

        let switzerland: CountryListModel | null = null;
        let liechtenstein: CountryListModel | null = null;
        let austria: CountryListModel | null = null;
        let italy: CountryListModel | null = null;

        for (let item of items) {
          if (item.code === CountryCodes.switzerland) {
            switzerland = item;
          }
          else if (item.code === CountryCodes.liechtenstein) {
            liechtenstein = item;
          }
          else if (item.code === CountryCodes.austria) {
            austria = item;
          }
          else if (item.code === CountryCodes.italy) {
            italy = item;
          }

          if (switzerland && liechtenstein && austria && italy) {
            break;
          }
        }

        let firstItems: CountryListModel[] = [];

        // commented out as per request, but can be easily re-enabled if needed in the future
        // requirement was to only have Switzerland on top, but if needed, the other countries can be added as well
        // if (liechtenstein) {
        //   firstItems.push(liechtenstein);
        // }

        // if (austria) {
        //   firstItems.push(austria);
        // }

        // if (italy) {
        //   firstItems.push(italy);

        firstItems = CollectionHelper.sortBy(firstItems, item => this.getItemName(item));

        // Switzerland always first
        if (switzerland) {
          firstItems = [switzerland, ...firstItems]
        }
        const remainingItems = CollectionHelper.sortBy(items.filter(item => !firstItems.includes(item)), item => this.getItemName(item));

        return [...firstItems, ...remainingItems];
      }));
  }

  getItemName = (item: any) => {
    return (item as ListItemModel)?.name;
  }

  onSelected(value: any) {
    this.selected.emit(value);
  }
}
